import React, { useEffect } from 'react';
import { useMsal } from './MsalContext';

const MsalAuthWrapper: React.FC = ({ children }) => {
  const { isAuthenticated, authInProgress, login } = useMsal();

  useEffect(() => {
    if (!isAuthenticated && !authInProgress) login();
  }, [authInProgress, isAuthenticated, login]);

  return isAuthenticated && !authInProgress ? <>{children}</> : null;
};

export default MsalAuthWrapper;
